/*
 * Hash function takes user email's local-part and encodes to base64.
 */
export const getAuthHash = ({ email }) => {
    return btoa(email.split('@')[0]);
};
